import Header from "../../Components/Header";
import Projects from "../../Components/Projects";
import ParticlesComponent from "../../Components/particles";

const PageProjects = () => {
  return (
    <div>
      <ParticlesComponent />
      <Header />
      <Projects />
    </div>
  );
};
export default PageProjects;
